import {ReactNode} from "react";
import {FormProvider, useForm} from "react-hook-form";

import {getBudgetFilterDefaultValues} from "../../../real_estate/utils/get_budget_filter_default_values";
import {ISearchFiltersFormValues} from "../../types/ISearchFiltersFormValues";
import {ISearchFormValues} from "../../types/ISearchFormValues";

interface IProps {
    children: ReactNode;
    defaultValues: ISearchFiltersFormValues;
}

export const FilterForm = (props: IProps) => {
    const formMethods = useForm({
        defaultValues: {
            ...props.defaultValues,
            ...getBudgetFilterDefaultValues(props.defaultValues as ISearchFormValues, "mid")
        }
    });

    return <FormProvider {...formMethods}>{props.children}</FormProvider>;
};
import {ReactNode} from "react";
import {FormProvider, useForm} from "react-hook-form";

import {getBudgetFilterDefaultValues} from "../../../real_estate/utils/get_budget_filter_default_values";
import {ISearchFiltersFormValues} from "../../types/ISearchFiltersFormValues";
import {ISearchFormValues} from "../../types/ISearchFormValues";

interface IProps {
    children: ReactNode;
    defaultValues: ISearchFiltersFormValues;
}

export const FilterForm = (props: IProps) => {
    const formMethods = useForm({
        defaultValues: {
            ...props.defaultValues,
            ...getBudgetFilterDefaultValues(props.defaultValues as ISearchFormValues, "mid")
        }
    });

    return <FormProvider {...formMethods}>{props.children}</FormProvider>;
};
